"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PayUIcons = _interopRequireDefault(require("../PayUIcons"));

require("../../assets/css/components/timeline.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TimelineCard(_ref) {
  var classNameProp = _ref.className,
      timeStamp = _ref.timeStamp,
      title = _ref.title,
      body = _ref.body,
      icon = _ref.icon,
      rest = _objectWithoutProperties(_ref, ["className", "timeStamp", "title", "body", "icon"]);

  return _react["default"].createElement("div", {
    className: "kt-timeline-v2__item ".concat(classNameProp)
  }, _react["default"].createElement("div", {
    className: "kt-timeline-v2__item-cricle ".concat(icon.className ? icon.className : "")
  }, _react["default"].createElement(_PayUIcons["default"], {
    type: icon.type,
    size: "20px",
    color: "primary"
  })), _react["default"].createElement("div", {
    className: "kt-timeline-v2__item-text kt-timeline-v2__item-text--bold"
  }, _react["default"].createElement("div", {
    className: "kt-flex"
  }, title, _react["default"].createElement("div", {
    className: "kt-timeline-v2__item-text kt-timeline-no-padding-left"
  }, body), _react["default"].createElement("div", {
    className: "kt-timeline-v2__item-text kt-timeline-no-padding-left"
  }, timeStamp))));
}

TimelineCard.propTypes = {
  className: _propTypes["default"].string,
  timeStamp: _propTypes["default"].string,
  title: _propTypes["default"].string,
  body: _propTypes["default"].string,
  icon: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    className: _propTypes["default"].string
  }).isRequired
};
TimelineCard.defaultProps = {
  className: "",
  timeStamp: "",
  title: "",
  body: ""
};
var _default = TimelineCard;
exports["default"] = _default;